import { useState, type ReactNode } from 'react';
import '@/styles/webreg/index.css';
import { WregAside } from './WregAside';
import { WregHelp } from './WregHelp';
import { WregTopbar } from './WregTopbar';
import { useWregDesktop } from './useWregDesktop';
import type { WregStep } from './wregSteps';

type Props = {
  step: WregStep;
  canBack: boolean;
  onBack: () => void;
  children: ReactNode;
  helpOpen?: boolean;
  onHelpOpenChange?: (open: boolean) => void;
};

const WregShell = ({ step, canBack, onBack, children, helpOpen, onHelpOpenChange }: Props) => {
  const isDesktop = useWregDesktop();
  const [ownHelpOpen, setOwnHelpOpen] = useState(false);
  const open = helpOpen ?? ownHelpOpen;
  const setOpen = (next: boolean) => {
    setOwnHelpOpen(next);
    onHelpOpenChange?.(next);
  };
  const body = (
    <div className="rg-surface" data-wreg-step={step}>
      {children}
    </div>
  );

  if (isDesktop) {
    return (
      <div className="reg-bw-body">
        <WregTopbar
          variant="desktop"
          canBack={canBack}
          onBack={onBack}
          onHelp={() => setOpen(true)}
        />
        <div className="reg-dt-cols">
          <WregAside step={step} />
          <div className="reg-dt-main">{body}</div>
        </div>
        <WregHelp open={open} onClose={() => setOpen(false)} />
      </div>
    );
  }

  return (
    <div className="reg-phone-screen">
      <WregTopbar
        variant="mobile"
        canBack={canBack}
        onBack={onBack}
        onHelp={() => setOpen(true)}
      />
      <div className="reg-mob-content">{body}</div>
      <WregHelp open={open} onClose={() => setOpen(false)} />
    </div>
  );
};

export { WregShell };
